var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg503(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 516,
    height: 216,
    viewBox: "0 0 516 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3837",
    "data-name": "Group 3837",
    transform: "translate(-146 -432)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_841",
    "data-name": "Ellipse 841",
    cx: 258,
    cy: 12,
    rx: 258,
    ry: 12,
    transform: "translate(146 624)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(274 432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36584",
    "data-name": "Path 36584",
    d: "M73.04,132.76,51.46,203.91H46.49l21.57-71.15Z",
    fill: "#ddb443"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36585",
    "data-name": "Path 36585",
    d: "M161.67,203.91H140.66l10.43-34.4Z",
    fill: "#fcedb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36586",
    "data-name": "Path 36586",
    d: "M260.44,203.91h-5.79l-21.87-71.15-6.51-21.15-2.13-6.93L197.26,17.24,197.74,0l2.39,7.77,29.8,96.91,2.13,6.93,6.5,21.15Z",
    fill: "#f9de87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36587",
    "data-name": "Path 36587",
    d: "M61.83,0,30.09,104.68,28,111.61l-6.42,21.15L0,203.91H46.49l21.57-71.15h46.51l-8.52,28.11h0l-13,43h42.67l12.91-42.57,2.77-9.12,5.9-19.46,3.34-11,3.07-10.12,2.1-6.93,6-19.8h0l23-75.8,3-9.07Zm1.73,5.2a2.18,2.18,0,1,1,4.3.5,2.18,2.18,0,1,1-4.3-.5Zm89.16,106.41H44.59s-5-.26-3.24-5.78h0l.95-1.13,34-40.53L96,40.72h0l16-19.14.12-.16.07-.07c.55-.5,3.94-3.38,7.39.07l.58,1.43,15.9,38.91h0l17.54,42.91.87,2.13h0C154.58,107.15,155.22,110.44,152.72,111.61ZM192.33,5.7a2.18,2.18,0,1,1-4.3-.5,2.18,2.18,0,1,1,4.3.5Z",
    fill: "#ffd64a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36588",
    "data-name": "Path 36588",
    d: "M254.65,203.91H208.36l-21.87-71.15H162.23l6.42-21.15,2.1-6.93,3.52-11.63v-.01l22.99-75.8,26.88,87.44,2.13,6.93,6.51,21.15Z",
    fill: "#fcedb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36589",
    "data-name": "Path 36589",
    d: "M167.24,203.91h-5.57l-10.58-34.4,2.77-9.13Z",
    fill: "#f9de87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36590",
    "data-name": "Path 36590",
    d: "M114.57,132.76l-8.52,28.11L97.4,132.76Z",
    fill: "#fcedb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36591",
    "data-name": "Path 36591",
    d: "M154.51,106.84h0l-.87-2.13L136.09,61.77h0l-15.9-38.91-.58-1.43c-3.45-3.45-6.84-.57-7.39-.07l-.07.07-.12.16L96,40.71h0L76.31,64.15l-34,40.53-.95,1.13h0c-1.76,5.52,3.24,5.78,3.24,5.78H152.72C155.22,110.44,154.58,107.15,154.51,106.84Zm-103-2.16L78.79,72.21,90.74,58l7.8-9.29h0L115.05,29l17.79,43.54L146,104.68Z",
    fill: "#67328f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36592",
    "data-name": "Path 36592",
    d: "M132.84,72.52,115.05,29,98.55,48.64h0L90.74,58,78.79,72.21,51.54,104.68H146ZM108.26,41.74h7l-5.23,23.94H106ZM107,67.4a2.37,2.37,0,1,1-2.41,2.37A2.37,2.37,0,0,1,107,67.4Zm-15.13,14H83.72L82.69,85a8.6,8.6,0,0,1,1.37-.07,7.72,7.72,0,0,1,5.24,1.71c1.38,1.19,2,3.12,1.54,5.84A10.21,10.21,0,0,1,80.4,100.6a10.9,10.9,0,0,1-5.62-1.35l1.61-4.07a9.71,9.71,0,0,0,4.53,1.16c2,0,4.39-1,4.81-3.52s-1-3.87-5.25-3.89a16,16,0,0,0-2.85.2l3.48-12.19H92.69Zm18.22,7.13c-1.24,7.16-4.72,12.12-10,12.1s-6.9-5.44-5.79-12c1.17-6.77,4.65-12,10.08-12,5.62.03,6.86,5.58,5.75,11.95Zm17.5-6a6.82,6.82,0,0,1-4.78,5.39V88c2.43.51,4.1,2.63,3.57,5.71-.71,4.08-4.5,7.07-9.83,7a10.41,10.41,0,0,1-6-1.64L112.33,95A9,9,0,0,0,117,96.45c2.56,0,4.09-1.34,4.39-3.06.4-2.32-1.49-3.37-3.66-3.38h-2l.67-3.9h1.94c1.65,0,3.85-.7,4.19-2.67.24-1.39-.58-2.44-2.68-2.45a10.09,10.09,0,0,0-4.61,1.38l-.32-3.94a13.6,13.6,0,0,1,6.8-1.72c4.43.01,6.46,2.64,5.91,5.82Z",
    fill: "#ffd64a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36593",
    "data-name": "Path 36593",
    d: "M197.74,0l-.48,17.24-22.99,75.8v.01l-3.52,11.63-2.1,6.93-6.42,21.15-8.37,27.62-2.77,9.13-10.43,34.4h-4.99l12.91-42.57,2.77-9.12,5.9-19.46,3.34-11.03,3.07-10.12,2.1-6.93,6-19.8v-.01l22.99-75.8Z",
    fill: "#ddb443"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36594",
    "data-name": "Path 36594",
    d: "M115.28,41.74l-5.23,23.94h-4.06l2.27-23.94Z",
    fill: "#67328f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36595",
    "data-name": "Path 36595",
    d: "M109.46,69.77A2.42,2.42,0,1,1,107,67.4a2.39,2.39,0,0,1,2.46,2.37Z",
    fill: "#67328f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36596",
    "data-name": "Path 36596",
    d: "M83.76,81.41,82.69,85a8.6,8.6,0,0,1,1.37-.07,7.72,7.72,0,0,1,5.24,1.71c1.38,1.19,2,3.12,1.54,5.84A10.21,10.21,0,0,1,80.4,100.6a10.9,10.9,0,0,1-5.62-1.35l1.61-4.07a9.71,9.71,0,0,0,4.53,1.16c2,0,4.39-1,4.81-3.52s-1-3.87-5.25-3.89a16,16,0,0,0-2.85.2l3.48-12.19H92.69l-.78,4.47Z",
    fill: "#67328f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36597",
    "data-name": "Path 36597",
    d: "M104.37,76.63c-5.43,0-8.91,5.26-10.08,12-1.11,6.58.35,12,5.79,12s8.81-4.94,10-12.1C111.24,82.21,110,76.66,104.37,76.63Zm.84,12c-.92,5.3-2.42,7.94-4.32,7.93s-2.6-2.55-1.68-7.88,2.61-7.94,4.38-7.93C105.57,80.75,106.1,83.48,105.21,88.63Z",
    fill: "#67328f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36598",
    "data-name": "Path 36598",
    d: "M105.21,88.63c-.92,5.3-2.42,7.94-4.32,7.93s-2.6-2.55-1.68-7.88,2.61-7.94,4.38-7.93C105.57,80.75,106.1,83.48,105.21,88.63Z",
    fill: "#ffd64a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36599",
    "data-name": "Path 36599",
    d: "M122.85,87.92V88c2.43.51,4.1,2.63,3.57,5.71-.71,4.08-4.5,7.07-9.83,7a10.41,10.41,0,0,1-6-1.64L112.33,95A9,9,0,0,0,117,96.45c2.56,0,4.09-1.34,4.39-3.06.4-2.32-1.49-3.37-3.66-3.38h-2l.67-3.9h1.94c1.65,0,3.85-.7,4.19-2.67.24-1.39-.58-2.44-2.68-2.45a10.09,10.09,0,0,0-4.61,1.38l-.32-3.94a13.6,13.6,0,0,1,6.8-1.72c4.47,0,6.5,2.64,5.95,5.82a6.82,6.82,0,0,1-4.82,5.39Z",
    fill: "#67328f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36600",
    "data-name": "Path 36600",
    d: "M67.86,5.7a2.18,2.18,0,1,1-4.3-.5,2.18,2.18,0,1,1,4.3.5Z",
    fill: "#67328f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36601",
    "data-name": "Path 36601",
    d: "M192.33,5.7a2.18,2.18,0,1,1-4.3-.5,2.18,2.18,0,1,1,4.3.5Z",
    fill: "#67328f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg503);
export default __webpack_public_path__ + "static/media/503.49297a1afa16badb4571a9936fbf1297.svg";
export { ForwardRef as ReactComponent };